/* SWEEPAW — accordéon <details> à hauteur animée (ouverture ET fermeture).
   Le natif ne bascule qu'entre display:none/block. Ici on intercepte le
   clic, on anime la hauteur du contenu, et on ne pose/retire l'attribut
   [open] qu'au bon moment (avant l'ouverture, après la fermeture) pour
   que le contenu reste mesurable/visible pendant toute la transition. */
(function () {
  var DURATION = 300;

  function cleanup(content) {
    content.style.transition = '';
    content.style.height = '';
    content.style.overflow = '';
  }

  function animateOpen(details, content) {
    details.open = true;
    var target = content.scrollHeight;
    content.style.overflow = 'hidden';
    content.style.height = '0px';
    content.getBoundingClientRect();
    content.style.transition = 'height ' + DURATION + 'ms ease';
    requestAnimationFrame(function () {
      content.style.height = target + 'px';
    });
    content.addEventListener(
      'transitionend',
      function handler(e) {
        if (e.propertyName !== 'height') return;
        content.removeEventListener('transitionend', handler);
        cleanup(content);
      },
      { once: true }
    );
  }

  function animateClose(details, content) {
    var current = content.scrollHeight;
    content.style.overflow = 'hidden';
    content.style.height = current + 'px';
    content.getBoundingClientRect();
    content.style.transition = 'height ' + DURATION + 'ms ease';
    requestAnimationFrame(function () {
      content.style.height = '0px';
    });
    content.addEventListener(
      'transitionend',
      function handler(e) {
        if (e.propertyName !== 'height') return;
        content.removeEventListener('transitionend', handler);
        cleanup(content);
        details.open = false;
      },
      { once: true }
    );
  }

  function init(details) {
    if (details.dataset.smoothReady) return;
    details.dataset.smoothReady = '1';

    var summary = details.querySelector('summary');
    var content = summary && summary.nextElementSibling;
    if (!summary || !content) return;

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (details.open) {
        animateClose(details, content);
      } else {
        animateOpen(details, content);
      }
    });
  }

  function boot(root) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    (root || document).querySelectorAll('details[data-smooth-accordion]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
